import { render, staticRenderFns } from "./userUpdatePasswordDialog.vue?vue&type=template&id=4bf93cf0&"
import script from "./userUpdatePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./userUpdatePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports